import { Divider } from 'antd';

const Gamunex = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">Important Safety Information</p>

        <p className="m-2">
          GAMUNEX®-C (immune globulin injection [human], 10% caprylate/chromatography purified) is
          approved to treat primary humoral immunodeficiency disease (PIDD) in patients 2 years of
          age and older. If you have PIDD, you may take GAMUNEX-C under the skin (subcutaneously) or
          in a vein (intravenously). GAMUNEX-C is also approved to treat idiopathic thrombocytopenic
          purpura (ITP) in adults and children and chronic inflammatory demyelinating polyneuropathy
          (CIDP) in adults. If you have ITP or CIDP, you may only take GAMUNEX-C intravenously.
        </p>

        <p className="m-2 font-bold">
          If you take GAMUNEX-C or a similar immune globulin product, you could experience a serious
          and lifethreatening blood clot (thromboembolism), which may include pain and/or swelling
          of an arm or leg with warmth over the affected area, discoloration of an arm or leg,
          unexplained shortness of breath, chest pain or discomfort that worsens on deep breathing,
          unexplained rapid pulse, numbness, or weakness on one side of the body. You are more
          likely to develop a blood clot if you have a history of hardening of the arteries
          (atherosclerosis), stroke, heart attack, or heart failure (low volume of blood pumped by
          the heart). You may also be more likely to get a blood clot if you are elderly, if you
          have a blood clotting disorder, if you are inactive for long periods of time (such as long
          bed rest), if you use estrogens, or if you have thickening of your blood. For patients at
          risk, GAMUNEX-C should be administered at the lowest dose and slowest infusion rate that
          is practical. However, blood clots may occur in the absence of any of the known risk
          factors. Patients should be well hydrated by drinking enough water before GAMUNEX-C is
          administered. Tell your doctor immediately if your medical history is similar to what is
          described here, and especially if you start having any of these symptoms while taking
          GAMUNEX-C.
        </p>

        <p className="m-2 font-bold">
          If you take GAMUNEX-C or a similar immune globulin product intravenously, you could
          experience serious kidney disease and death. You may have symptoms of decreased urination,
          sudden weight gain, swelling in your legs (edema), or shortness of breath. You are more
          likely to develop serious kidney disease if you already have a kidney problem, have Type
          II diabetes mellitus, or are older than 65. You are more likely to develop serious kidney
          disease if you are dehydrated, have a blood infection (sepsis), have high protein content
          in your blood, or if you are receiving other medicines that are harmful to your kidneys.
          Tell your doctor immediately if your medical history is similar to what is described here,
          and especially if you start having any of these symptoms while taking GAMUNEX-C.
        </p>

        <p className="m-2 font-bold">
          You are more likely to develop serious kidney disease if you take an intravenous immune
          globulin product that contains sugar (sucrose). GAMUNEX-C does not contain sugar. If your
          situation makes you more likely to experience serious kidney disease, you should take
          GAMUNEX-C at the lowest concentration available and the slowest infusion rate that is
          practical.
        </p>

        <p className="m-2">
          Do not take GAMUNEX-C if you have an allergy to immune globulin. Tell your doctor if you
          have had a serious reaction to other medicines that contain human immune globulin. Also
          tell your doctor if you have immunoglobulin A (IgA) deficiency. If you have a serious
          reaction while taking GAMUNEX-C, stop taking it immediately and tell your doctor.
        </p>

        <p className="m-2">
          Periodic monitoring of kidney function and urine output is particularly important in
          patients more likely to experience severe kidney disease.
        </p>

        <p className="m-2">
          You could experience other serious and life-threatening problems due to immune globulin.
          You could get aseptic meningitis (a type of brain inflammation with symptoms of severe
          headache, stiff neck, fatigue, fever, sensitivity to light, painful eye movements, nausea,
          and vomiting), a blood problem called hemolytic anemia (common symptoms include increased
          heart rate, fatigue, yellow skin or eyes, and dark-colored urine), and/or a lung problem
          called transfusion-related acute lung injury (commonly referred to as TRALI). TRALI is a
          condition where you build up fluid in the lungs (called pulmonary edema) that is not the
          result of heart failure.
        </p>

        <p className="m-2">
          If you have higher than normal body fluid volumes or if you have a condition where
          increasing body fluid volume may be a concern, a higher dose, such as 1g/kg for 1-2 days,
          is not recommended.
        </p>

        <p className="m-2">
          Because GAMUNEX-C (immune globulin injection [human], 10% caprylate/chromatography
          purified) is made from human blood, it may carry a risk of transmitting infectious agents
          such as viruses, the variant CreutzfeldtJakob disease (vCJD) agent, and, theoretically,
          the Creutzfeldt-Jakob disease (CJD) agent.
        </p>

        <p className="m-2">
          You may not take GAMUNEX-C subcutaneously if you have ITP. If you have ITP and take
          GAMUNEX-C subcutaneously, you could experience a very serious and life-threatening black
          and blue wound (hematoma, which is a pocket of blood within a tissue).
        </p>

        <p className="m-2">
          After you take GAMUNEX-C, your blood antibody levels may rise, which could cause some
          blood antibody tests to give false results.
        </p>

        <p className="m-2">
          The most common side effects in a clinical study with PIDD patients who got subcutaneous
          injections of GAMUNEX-C were infusion-site reactions such as redness, swelling, and
          itching; extreme tiredness; pain in the region of the head or neck; a runny nose, nasal
          congestion, sneezing, cough, and sputum production; joint pain; loose stools; a sensation
          of unease and discomfort in the upper stomach; swelling of the tissue lining the sinuses;
          inflammation of the airways that carry air to your lungs; a feeling of unhappiness,
          sadness, melancholy, gloom, hopelessness, or low spirits; red rash or bumps, itchy,
          swollen, and tender skin with or without blisters or a burning feeling; a severe throbbing
          pain or a pulsing sensation, usually on just one side of the head; muscle pain; familiar
          infectious diseases such as the common cold or flu; and raised body temperature or fever.
          In clinical studies with PIDD patients who got GAMUNEX-C intravenously, the most common
          side effects were cough; irritation and inflammation of the mucous membrane inside the
          nose; sore throat caused by inflammation of the back of the throat; pain in the region of
          the head or neck; a condition in which your airways narrow and swell and produce extra
          mucus; a sensation of unease and discomfort in the upper stomach; raised body temperature
          or fever; loose stools; and swelling of the tissue lining the sinuses. In a clinical study
          with CIDP patients who got GAMUNEX-C intravenously, the most common side effects were pain
          in the region of the head or neck; raised body temperature or fever; abnormally high blood
          pressure; feelings of coldness accompanied by shivering; a noticeable change in the
          texture or color of your skin such as your skin becoming scaly, bumpy, itchy, or otherwise
          irritated; a sensation of unease and discomfort in the upper stomach; joint pain; and
          abnormal physical weakness or lack of energy. In clinical trials with ITP patients who got
          GAMUNEX-C intravenously, the most common side effects were pain in the region of the head
          or neck; a discoloration of the skin resulting from bleeding underneath, typically caused
          by bruising; vomiting, fever, nausea, rash, abdominal pain, back pain, and a pain or an
          uncomfortable feeling in the upper middle part of your stomach.
        </p>

        <p className="m-2">
          The most serious side effects in clinical studies were a blood clot to the lung (pulmonary
          embolism) in 1 patient with a history of this condition (in CIDP), a flare-up of an
          existing type of anemia (autoimmune pure red cell aplasia) in 1 patient (in PIDD), and
          heart inflammation (myocarditis) in 1 patient (in ITP).
        </p>

        <div>
          <p className="m-2">
            <b>
              Please see
              <a
                target="_blank"
                href="/Gamunex-Prescribing-Information.pdf"
                className="text-blue-500"
              >
                &nbsp; GAMUNEX-C full Prescribing Information&nbsp;
              </a>
              for complete prescribing details.
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of prescription drugs to the FDA.
              Visit
              <a target="_blank" href="http://www.fda.gov/medwatch" className="text-blue-500">
                &nbsp;www.fda.gov/medwatch&nbsp;
              </a>
              or call 1-800-FDA-1088.
            </b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Gamunex;
